import React from "react";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { GrInstagram } from "react-icons/gr";

const team = [
  {
    image: "/images/team/512x512.webp",
    name: "Jone Due",
    job: "Sr. Web Developer",
    desc: "Bonnie drives the technical strategy of the flowbite platform and brand.",
    social: [
      { icon: <FaFacebookF />, url: "https://facebook.com" },
      { icon: <GrInstagram />, url: "https://instagram.com" },
      { icon: <FaLinkedinIn />, url: "https://linkedin.com" },
      { icon: <FaTwitter />, url: "https://twitter.com" },
    ],
  },
  {
    image: "/images/team/512x512.webp",
    name: "Jone Due",
    job: "Sr. Web Developer",
    desc: "Bonnie drives the technical strategy of the flowbite platform and brand.",
    social: [
      { icon: <FaFacebookF />, url: "https://facebook.com" },
      { icon: <GrInstagram />, url: "https://instagram.com" },
      { icon: <FaLinkedinIn />, url: "https://linkedin.com" },
      { icon: <FaTwitter />, url: "https://twitter.com" },
    ],
  },
  {
    image: "/images/team/512x512.webp",
    name: "Jone Due",
    job: "Sr. Web Developer",
    desc: "Bonnie drives the technical strategy of the flowbite platform and brand.",
    social: [
      { icon: <FaFacebookF />, url: "https://facebook.com" },
      { icon: <GrInstagram />, url: "https://instagram.com" },
      { icon: <FaLinkedinIn />, url: "https://linkedin.com" },
      { icon: <FaTwitter />, url: "https://twitter.com" },
    ],
  },
  {
    image: "/images/team/512x512.webp",
    name: "Jone Due",
    job: "Sr. Web Developer",
    desc: "Bonnie drives the technical strategy of the flowbite platform and brand.",
    social: [
      { icon: <FaFacebookF />, url: "https://facebook.com" },
      { icon: <GrInstagram />, url: "https://instagram.com" },
      { icon: <FaLinkedinIn />, url: "https://linkedin.com" },
      { icon: <FaTwitter />, url: "https://twitter.com" },
    ],
  },
];

export default team;